import { NavLink, Link } from 'react-router-dom';
import {
  LayoutDashboard,
  Package,
  Users,
  Truck,
  ShoppingBag,
  FileText,
  TruckIcon,
  BarChart3,
  Settings,
  Layers,
  Share2,
  ChevronLeft,
  ChevronRight,
  FileCheck,
  RefreshCw,
  CreditCard,
  Calendar,
  DollarSign,
  Heart,
} from 'lucide-react';
import { useUIStore } from '../../store/uiStore';

const menuItems = [
  { icon: LayoutDashboard, label: 'Dashboard', path: '/dashboard' },
  { icon: Layers, label: 'Categorías', path: '/categorias' },
  { icon: Package, label: 'Productos', path: '/productos' },
  { icon: Users, label: 'Clientes', path: '/clientes' },
  { icon: Truck, label: 'Proveedores', path: '/proveedores' },
  { icon: Package, label: 'Envíos', path: '/envios' },
  { icon: DollarSign, label: 'Ventas', path: '/ventas' },
  { icon: CreditCard, label: 'Gastos', path: '/gastos' },
  { icon: FileText, label: 'Facturas', path: '/facturas' },
  { icon: FileText, label: 'Cuotas', path: '/cuotas' },
  { icon: FileCheck, label: 'Comprobantes', path: '/comprobantes' },
  { icon: TruckIcon, label: 'Remitos', path: '/remitos' },
  { icon: ShoppingBag, label: 'Compras', path: '/compras' },
  { icon: ShoppingBag, label: 'Mayoristas', path: '/mayoristas' },
  { icon: RefreshCw, label: 'Devoluciones', path: '/devoluciones' },
  { icon: Calendar, label: 'Calendario', path: '/calendario' },
  { icon: Share2, label: 'Social', path: '/social' },
  { icon: BarChart3, label: 'Reportes', path: '/reportes' },
  { icon: Heart, label: 'Promociones', path: '/promociones' },
  { icon: Settings, label: 'Configuración', path: '/configuracion' },
];

export function Sidebar() {
  const { sidebarOpen, toggleSidebar, setSidebarOpen } = useUIStore();

  return (
    <aside
      className={`fixed left-0 top-0 h-full bg-white shadow-lg transition-all duration-300 z-50 flex flex-col
        ${sidebarOpen 
          ? 'translate-x-0 w-64' 
          : '-translate-x-full w-64 md:translate-x-0 md:w-20'
        }
      `}
    >
      {/* Título clickeable */}
      <Link 
        to="/dashboard" 
        className={`p-4 border-b block hover:bg-gray-50 transition-colors ${
          sidebarOpen ? 'text-left' : 'text-center'
        }`}
        onClick={() => {
          if (window.innerWidth < 768) setSidebarOpen(false);
        }}
      >
        <h1 className={`font-bold text-blue-600 ${sidebarOpen ? 'text-xl' : 'text-sm'}`}>
          {sidebarOpen ? 'Gestor Stock' : 'GS'}
        </h1>
      </Link>

      <nav className="flex-1 overflow-y-auto p-4 space-y-1">
        {menuItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            onClick={() => {
              if (window.innerWidth < 768) setSidebarOpen(false);
            }}
            className={({ isActive }) =>
              `flex items-center ${sidebarOpen ? 'gap-3 px-4' : 'justify-center'} py-3 rounded-lg transition-colors ${
                isActive
                  ? 'bg-blue-50 text-blue-600'
                  : 'text-gray-600 hover:bg-gray-50 hover:text-blue-600'
              }`
            }
          >
            <item.icon size={20} className="flex-shrink-0" />
            {sidebarOpen && <span className="text-sm font-medium">{item.label}</span>}
          </NavLink>
        ))}
      </nav>

      <button
        onClick={toggleSidebar}
        className="hidden md:flex p-4 border-t hover:bg-gray-50 transition-colors items-center justify-center text-gray-500"
      >
        {sidebarOpen ? <ChevronLeft size={20} /> : <ChevronRight size={20} />}
      </button>
    </aside>
  );
}